import * as React from 'react';
import { holV } from './holiday';
import { holidayDesign, NONE_THEME_ID } from './registry';
import { HOLIDAY_THEMES_ENABLED } from './flags';
import { HolidayContext } from './context';
import { holidayRegion, scheduledThemeId } from './schedule';
import { useCalendarDay } from './useCalendarDay';

const DECOR_HIDDEN = { display: 'none' } as const;

/**
 * Plays the theme the holiday schedule gives for the viewer's calendar day, and None outside every window.
 * While `HOLIDAY_THEMES_ENABLED` is false it plays None on every day.
 * `firstName` is the viewer's first name for the greeting; the engine drops the name tail without one.
 * `hideDecor` is set on project screens (Handoff section 3), whose rail and header the decor does not fit:
 * both decor layers resolve to `display: none` and nothing else changes.
 */
export function HolidayProvider(props: { children: React.ReactNode; firstName?: string | null; hideDecor?: boolean }) {
  const day = useCalendarDay();
  const region = React.useMemo(
    () => holidayRegion(window.navigator.language, Intl.DateTimeFormat().resolvedOptions().timeZone),
    [],
  );
  const themeId = HOLIDAY_THEMES_ENABLED ? scheduledThemeId(day, region) : NONE_THEME_ID;
  const firstName = props.firstName ?? '';
  const hideDecor = props.hideDecor === true;
  const value = React.useMemo(() => {
    const { designName, dv } = holidayDesign(themeId);
    const out = holV(designName, 'C', dv, dv, firstName);
    return { themeId, hol: hideDecor ? { ...out, decor: DECOR_HIDDEN, headDecor: DECOR_HIDDEN } : out };
  }, [themeId, firstName, hideDecor]);
  return <HolidayContext.Provider value={value}>{props.children}</HolidayContext.Provider>;
}
